import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../settings/constants';

const lazy = {
    SettingsPage: lazyLoad(async () => {
        const { SettingsPage } = await import('./Settings');

        return { default: SettingsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.settings.title',
        page: lazy.SettingsPage,
        path: route.patterns.settings,
    },
];
